(() => {
  const initGlamoraEnchapeLanding = () => {
    if (!document.querySelector('[data-glamora-enchape]')) return;

    const finishScroll = (target, selector) => {
      if (!target.hasAttribute('tabindex')) target.setAttribute('tabindex', '-1');
      target.focus({ preventScroll: true });

      const currentUrl = new URL(window.location.href);
      currentUrl.hash = selector;
      window.history.replaceState(null, '', currentUrl.toString());
    };

    const scrollGentlyTo = (target, selector) => {
      const header = document.querySelector('.site-header');
      const headerOffset = header ? header.getBoundingClientRect().height + 16 : 16;
      const startPosition = window.scrollY;
      const targetPosition = Math.max(
        0,
        target.getBoundingClientRect().top + startPosition - headerOffset
      );
      const distance = targetPosition - startPosition;
      const reduceMotion = window.matchMedia('(prefers-reduced-motion: reduce)').matches;

      if (reduceMotion || Math.abs(distance) < 2) {
        window.scrollTo(0, targetPosition);
        finishScroll(target, selector);
        return;
      }

      const duration = 850;
      const startedAt = performance.now();
      const easeInOutCubic = (progress) =>
        progress < 0.5
          ? 4 * progress * progress * progress
          : 1 - Math.pow(-2 * progress + 2, 3) / 2;

      const animate = (now) => {
        const progress = Math.min((now - startedAt) / duration, 1);
        window.scrollTo(0, startPosition + distance * easeInOutCubic(progress));

        if (progress < 1) {
          window.requestAnimationFrame(animate);
        } else {
          finishScroll(target, selector);
        }
      };

      window.requestAnimationFrame(animate);
    };

    document.querySelectorAll('[data-glamora-scroll]').forEach((link) => {
      link.addEventListener('click', (event) => {
        const selector = link.getAttribute('href');
        if (!selector || !selector.startsWith('#')) return;

        const target = document.querySelector(selector);
        if (!target) return;

        event.preventDefault();
        scrollGentlyTo(target, selector);
      });
    });
  };

  if (document.readyState === 'loading') {
    document.addEventListener('DOMContentLoaded', initGlamoraEnchapeLanding, { once: true });
  } else {
    initGlamoraEnchapeLanding();
  }
})();
